import { render, staticRenderFns } from "./ChoosePortePage.vue?vue&type=template&id=6633a8da&scoped=true&"
import script from "./ChoosePortePage.vue?vue&type=script&lang=ts&"
export * from "./ChoosePortePage.vue?vue&type=script&lang=ts&"
import style0 from "./ChoosePortePage.vue?vue&type=style&index=0&id=6633a8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6633a8da",
  null
  
)

export default component.exports